import { Injectable } from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import {AppSettingsService} from './appsettings.service';
import {AppSettings} from '../app.settings';
import { ErrorStateMatcher } from '@angular/material/core';
import {ApplicationInfo} from '../models/ApplicationInfo';





@Injectable()
export class AuthenticationService {

  loggedIn: boolean;
  urlString: string;
  private settings: AppSettings;
  SEARCHBYUSERNAMEENDPOINT: string;
  private appInfo: ApplicationInfo;


  headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8',
   // Accept: 'application/json; charset=utf-8',
    'Access-Control-Allow-Headers': '*',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': '*',
    Authorization: 'Bearer ' + localStorage.getItem('auth_token')
  });


    constructor(private http: HttpClient, private appSettingsService: AppSettingsService) {
      this.loggedIn = !!localStorage.getItem('auth_token');


      this.appSettingsService.getSettings().subscribe(settings => this.settings = settings,
    () => null,
    () => {
      this.urlString = this.settings.lhcsaAPI;
    });


      this.SEARCHBYUSERNAMEENDPOINT = this.urlString + '/api/authentication/SearchByUsername/?';


     }



    login(email: string, password: string) {


      return this.http.post<any>(this.urlString + '/api/authentication/Login', {
            email,
            password
          }, {
            headers: this.headers
          })
          .pipe(map(res => {

            this.dataModel = res;

            localStorage.setItem('auth_token', res.auth_token);
            localStorage.setItem('id', res.id);
            localStorage.setItem('enroll_type', res.enroll_type);
            localStorage.setItem('employee_name', res.employeeName);
            this.loggedIn = true;



            // this._authNavStatusSource.next(true);
            return res.retvalue;
          }), catchError(error => {
           // console.log('Login to the server failed', error.error.text);

           const emessage = {
              userName: email,
              // tslint:disable-next-line:max-line-length
              eMessage: 'Username: ' + email + '<br><br> Error Message  ' + error.message + 'Error Status Details  ' + error.status + '    ' + error.statusText + '    ' + error.name
           };

           this.sendErrorEmail(emessage).subscribe(
            devresult => {

            });


           return of({
              results: 'Invalid credentials'
            });
          }));

     }


     SignUpApplicant(emailvalue: any) {

      const emailheader = new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8',
        // Accept: 'application/json; charset=utf-8',
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
        'Access-Control-Allow-Methods': '*' ,
       // tslint:disable-next-line:max-line-length
      //  Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('currentUser')).token
      });


      const currentuser = localStorage.getItem('currentUser');
      const obj = JSON.parse(currentuser);
      // the

      const registrationData = {
        firstName: emailvalue.firstName,
        lastName: emailvalue.lastName,
        email: emailvalue.email,
        password: emailvalue.password,
        addedBy: 'SYSTEM'
      };

      return this.http.post<any>(
        this.urlString + '/api/authentication/Register',
        registrationData,
        { headers: emailheader }
      ).pipe(
        // retry(1),
        catchError((err) => {
         return  this.handleError(err, 'sendRegisteredEmail');
        }
        )

      );
    }



  searchByUsername(term) {
    const params = new HttpParams().set('term', term);
    return this.http.get(this.SEARCHBYUSERNAMEENDPOINT, {
      params,
      headers: this.headers,
    }).pipe(
      catchError((err) => {
       return  this.handleError(err, 'searchByUsername');
      }
      )

    );
  }


  captureDeviceInfo =  (postData) => {
    const data = JSON.stringify(postData);

    return  this.http.post<any>(this.urlString + '/api/authentication/CaptureClientDeviceInfo', postData, {headers: this.headers});

    }


     sendErrorEmail(errormessage: any) {

      return  this.http.post<any>(this.urlString + '/api/authentication/SendErrorEmail', errormessage, { headers: this.headers});
    }


    SendErrorLog(errorlog: any): Observable<any> {

     // tslint:disable-next-line:max-line-length
      return this.http.post<any>( this.urlString + '/api/Error/SaveErrorLog', errorlog, {
       headers: this.headers,
     });
   }


         sendemail(email: string) {

          return this.http.post<any>(this.urlString + '/api/authentication/ForgotPassword', { email }, {headers: this.headers})
          .pipe(map(res => {
            // this._authNavStatusSource.next(true);
            const results = res.email;
            return results;
          }), catchError(error => {
           // console.log('Login to the server failed', error.error.text);
           const emessage = {
              userName: email,
              // tslint:disable-next-line:max-line-length
              eMessage: 'Username: ' + email + '<br><br>Reset Password Error Message  ' + error.message + 'Error Status Details  ' + error.status + '    ' + error.statusText + '    ' + error.name
           };

           this.sendErrorEmail(emessage).subscribe(
            devresult => {

            });

           return of({
              results: 'Invalid credentials'
            });
          }));

         }



  resetpword(resetPasswordModel: any) {

    return this.http.post<any>(this.urlString + '/api/authentication/ResetPassword', resetPasswordModel, {headers: this.headers});

  }


  isAuthenticated() {
    return this.loggedIn;
  }




    logout() {
        // remove user from local storage to log user out
        this.loggedIn = false;
        localStorage.removeItem('auth_token');
        localStorage.removeItem('id');
        localStorage.removeItem('enroll_type');
        localStorage.removeItem('employee_name');


    }



    public get dataModel(): ApplicationInfo {

      //  console.log('Indatamodel', this.generalForm);
        return this.appInfo;
      }

      public set dataModel(val: ApplicationInfo) {

        this.appInfo = val;

      }



    handleError(error, method) {


      const errortype = method;
      let uname = '';

      if (errortype !== 'sendRegisteredEmail') {
        const currentuser = localStorage.getItem('currentUser');
        const obj = JSON.parse(currentuser);

        uname = obj.username;

      }
      let errorMessage = '';


      if (error.error instanceof ErrorEvent) {

        // client-side error

        errorMessage = `Error: ${error.error.message}`;

        const errorLog = {
        source: 'Client Side Error, Method:' + method,
        error: errorMessage,
        username: uname };

        this.SendErrorLog(errorLog).subscribe((test) => {
    });

      } else {

        // server-side error

        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;

        const errorLog = {
          source: 'Client: Server Side Error, Method:' + method,
          error: errorMessage,
          username: uname };

        this.SendErrorLog(errorLog).subscribe((test) => {
      });

      }

    //  window.alert(errorMessage);

      return throwError(errorMessage);

   }

}






